import { MEDIA } from "@/config/media";
import { Reveal, SectionLabel } from "./Reveal";

const STEPS = [
  {
    n: "1",
    t: "Discovery call",
    d: "15 minutes on your budget, loan eligibility, family needs and possession timeline. No inventory pushed yet.",
  },
  {
    n: "2",
    t: "Shortlist in 48 hours",
    d: "A written comparison of 3–5 options across the corridor with all-in pricing and diligence flags.",
  },
  {
    n: "3",
    t: "Chauffeured site visits",
    d: "We plan the route, host the visits and ask the awkward questions on your behalf.",
  },
  {
    n: "4",
    t: "Negotiation, loan & registry",
    d: "We negotiate the final rate, coordinate the bank and stay with you until the registry is done.",
  },
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="bg-white py-20 lg:py-28">
    <div className="mx-auto max-w-[1280px] px-5 lg:px-8">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <SectionLabel index="03">How it works</SectionLabel>
            <h2 className="mt-5 font-display text-3xl font-extrabold leading-tight text-ink sm:text-4xl">
              Four steps from confusion to keys
            </h2>
            <p className="mt-4 max-w-md text-base text-body">
              A single advisor stays with you through the entire journey — no handoffs, no call
              centre, no pressure.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-8 overflow-hidden rounded-2xl border border-line">
              <img
                src={MEDIA.advisory}
                alt="BRICKSPACE advisor reviewing a site plan with clients"
                className="h-[260px] w-full object-cover lg:h-[320px]"
              />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="space-y-4">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.07}>
                <div className="card-soft card-hover flex gap-5 p-6">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-ink font-display text-sm font-bold text-white">
                    {s.n}
                  </span>
                  <div>
                    <h3 className="font-display text-lg font-bold text-ink">{s.t}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-body">{s.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
